// TODO: Move to global constants folder

export enum AssetEventMessageTypes {
  DANGER = 'danger',
  DEBUG = 'debug',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}
